import React from 'react';
import { TextField } from '../TextField/TextField';
import cs from 'classnames';
export var QuickSearch = function QuickSearch(props) {
  var animated = props.animated;
  return /*#__PURE__*/React.createElement("div", {
    className: cs('telia-quick-search', {
      'telia-quick-search--animated': animated
    })
  }, /*#__PURE__*/React.createElement(TextField, props));
};